import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const baseQuery = fetchBaseQuery({
    baseUrl: `/`
})

export const authAPI = createApi({
    reducerPath: 'authAPI',
    baseQuery,
    endpoints: builder => ({})
})

export const authAPIReducer = authAPI.reducer
export const resetAuthAPI = authAPI.util.resetApiState